<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-object-group"></i> Blending
                </div>
                <div class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                    <button v-if="$can('create blending')" type="button" class="btn btn-primary" @click="addNew">
                        <i class="fas fa-plus-square"></i> Blending
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="api/blendings"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="gudang" slot-scope="props">
                            <span>
                                {{ props.rowData.gudang.name }}
                            </span>
                        </template>
                        <template slot="status" slot-scope="props">
                            <span v-if="props.rowData.status == 'Selesai'" class="badge badge-pill badge-success">{{ props.rowData.status }}</span>
                            <span v-else-if="props.rowData.status == 'Blending'" class="badge badge-pill badge-warning">{{ props.rowData.status }}</span>
                            <span v-else>-</span>
                        </template>
                        <template slot="action" slot-scope="props">
                            <button type="button" title="View" @click="view(props.rowData)" class="btn btn-link px-1"><i class="fas fa-eye"></i></button>
                            <button v-if="($can('edit blending') && isBeforeDay(props.rowData.tanggal_blending)) || isSuperAdmin" type="button" title="Edit" @click="edit(props.rowData)" class="btn btn-link px-1"><i class="fas fa-edit"></i></button>
                            <button v-if="($can('penerimaan blending') && isAllowApprove(props.rowData.penerimaan)) || isSuperAdmin" type="button" title="Penerimaan" @click="penerimaan(props.rowData)" class="btn btn-link px-1"><i class="fas fa-vote-yea"></i></button>
                            <button v-if="isSuperAdmin" type="button" title="Delete" @click="deleteItem(props.rowData)" class="btn btn-link px-1 text-danger"><i class="fas fa-trash-alt"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="editModal" size="lg" :hide-header="true" :hide-footer="true">
            <edit-form :isEdit="isEdit" :value="currentBlending" @saved="saved" @cancel="editModal = false"></edit-form>
		</b-modal>

        <b-modal v-model="viewModal" size="lg" :hide-header="true" :hide-footer="true">
            <viewer :value="currentBlending" @cancel="viewModal = false"></viewer>
		</b-modal>

        <b-modal v-model="showPenerimaan" size="lg" :hide-header="true" :hide-footer="true">
            <viewer is-penerimaan :value="currentBlending" @saved="saved" @cancel="showPenerimaan = false"></viewer>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import EditForm from './Form';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';
import Viewer from './Viewer';

export default {
    name: "blending",

    components: {
        EditForm,
        SearchBar,
        Viewer,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentBlending: null,
            searchText: '',
            searchDate: '',
            searchStatus: '',
            searchGudangId: '',
            editModal: false,
            viewModal: false,
            showScanQrCode: false,
            isPreview: false,
            isEdit: false,
            showPenerimaan: false,
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'tanggal_blending',
                    title: 'Tanggal Blending',
                    sortField: 'tanggal_blending',
                    callback: 'formatDate',
                },
                {
                    name: 'penerimaan.created_at',
                    title: 'Tanggal Selesai',
                    sortField: 'tanggal_tiba',
                    callback: 'formatDate',
                },
                {
                    name: '__slot:gudang',
                    title: 'Gudang',
                    sortField: 'gudang_name',
                },
                {
                    name: 'bobot_berangkat',
                    title: 'Berat Awal (kg)',
                    callback: 'formatNumber',
                },
                {
                    name: 'bobot_tiba',
                    title: 'Berat Selesai (kg)',
                    callback: 'formatNumber',
                },
                {
                    name: 'penerimaan.biaya',
                    title: 'Biaya',
                    sortField: 'penerimaan_biaya',
                    callback: 'formatNumber',
                },
                {
                    name: '__slot:status',
                    title: 'Status',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                status: this.searchStatus,
                gudang_id: this.searchGudangId,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchStatus = search.searchStatus;
            this.searchGudangId = search.searchGudangId;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchStatus = '';
            this.searchGudangId = '';
            this.refresh();
        },

        addNew() {
            this.isEdit = false;
            this.currentBlending = null;
            this.editModal = true;
        },

        edit(rowData) {
            this.isEdit = true;
            this.currentBlending = Object.assign({}, rowData);
            this.editModal = true;
        },

        view(rowData) {
            this.currentBlending = Object.assign({}, rowData);
            this.viewModal = true;
        },

        saved() {
            this.editModal = false;
            this.isEdit = false;
            this.showPenerimaan = false;
            this.showPelunasan = false;
            this.refresh();
        },

        isAllowApprove(data) {
            if (!data) {
                return true;
            }
            return this.isSameDay(data.created_at);
        },

        penerimaan(pindahGudang) {
            this.currentBlending = Object.assign({}, pindahGudang);
            this.showPenerimaan = true;
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/blendings/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        deleteItem(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/blendings/' + rowData.id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.isLoading = false;
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },
    },
}
</script>
